import {$clientApi} from "../http";
import {IVenue, IVenueBookRequest} from "../models/Venue";
import moment from "moment";

class VenueServiceClass {

    getStartHours() {
        const startHours = new Array(48);
        let minutes = 0;
        for (let i = 0; i < startHours.length; i++) {
            startHours[i] = {startDate: new Date(2021, 1, 1, 0, minutes)};
            minutes += 30;
        }
        return startHours.map((el, id) => {
            return {
                id,
                startDate: el.startDate,
                label: this.getHourLabel(el.startDate)
            }
        });
    }

    getEndHours() {
        const endHours = new Array(48);
        let minutes = 30;
        for (let i = 0; i < endHours.length; i++) {
            endHours[i] = {endDate: new Date(2021, 1, 1, 0, minutes)};
            if (i === 47) {
                endHours[i] = {endDate: new Date(2021, 1, 1, 23, 59)};
                break;
            }
            minutes += 30;
        }
        return endHours.map((el, id) => {
            return {
                id,
                endDate: el.endDate,
                label: this.getHourLabel(el.endDate)
            }
        });
    }

    getHourLabel(date: Date) {
        return moment(date).format("HH:mm");
    }

    async bookTrainingRooms(model: IVenueBookRequest) {
        return $clientApi.post<boolean>("api/room-reservation/book-rooms", model);
    }

    async getVenues() {
        return $clientApi.get<IVenue[]>("api/public/training-rooms");
    }

    async getAvailableRoomsByRange(model: {startDate: {timestamp: string}, endDate: {timestamp: string} }) {
        return $clientApi.post<{startDate: string, endDate: string, trainingRooms: IVenue[]}>("api/trainning-rooms/available-rooms-by-range", model);
    }

}

export const VenueService = new VenueServiceClass();